import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import {
  DIRECTORY_PAGE_SIZE,
  getProfileByHandle,
  getProfileStats,
  listDistinctCountries,
  listMapProfiles,
  listProfiles,
  listRandomPreview,
  type ProfileFilters,
} from '@/lib/api/profiles';

export function useProfiles(filters: ProfileFilters) {
  return useInfiniteQuery({
    queryKey: ['profiles', 'list', filters],
    queryFn: ({ pageParam = 0 }) => listProfiles(filters, pageParam),
    initialPageParam: 0,
    getNextPageParam: (last, pages) =>
      last.hasMore ? pages.length : undefined,
    staleTime: 30_000,
  });
}

export function useProfile(handle: string | undefined) {
  return useQuery({
    queryKey: ['profile', handle],
    queryFn: () => getProfileByHandle(handle!),
    enabled: !!handle,
    staleTime: 60_000,
  });
}

export function useMapProfiles() {
  return useQuery({
    queryKey: ['profiles', 'map'],
    queryFn: () => listMapProfiles(1000),
    staleTime: 5 * 60_000,
  });
}

export function useProfileStats() {
  return useQuery({
    queryKey: ['profiles', 'stats'],
    queryFn: getProfileStats,
    staleTime: 5 * 60_000,
  });
}

export function useDistinctCountries() {
  return useQuery({
    queryKey: ['profiles', 'countries'],
    queryFn: listDistinctCountries,
    staleTime: 10 * 60_000,
  });
}

export function useRandomPreview(count: number) {
  return useQuery({
    queryKey: ['profiles', 'preview', count],
    queryFn: () => listRandomPreview(count),
    staleTime: 60_000,
  });
}

export { DIRECTORY_PAGE_SIZE };
